import { useContext } from "react";
import BusinessProfileContex from "../../context/businessProfileContext";

export const useBusinessProfile = () => {
  const context = useContext(BusinessProfileContex);
  if (context === undefined) {
    throw new Error(
      "useBusinessProfile deve essere usato all'interno di BusinessPorfileProvider"
    );
  }
  return context;
};
